import { supabase } from '../lib/supabase';

// Web-equivalent van getClientLessonDetail in de mobiele datalaag. De client
// krijgt uitsluitend tellingen, de eigen inschrijving en geaccepteerde
// buddy-deelname; nooit de deelnemerslijst van andere cliënten.
export async function getClientLessonDetail(lessonId, clientId) {
  if (!lessonId) return null;

  const [lessonRes, countsRes, ownRes, buddyRes] = await Promise.all([
    supabase
      .from('group_lessons')
      .select(`
        id, name, description, type, starts_at, duration_minutes,
        min_participants, max_participants, credit_cost, cancel_deadline_hours,
        bring_items, is_cancelled, cancel_reason,
        category:training_categories(id, slug, name, icon_name, accent_color),
        custom_location_name, custom_location_street, custom_location_house_number,
        custom_location_postal_code, custom_location_city,
        location:locations(id, name, street, house_number, postal_code, city, image_url),
        coach:coach_basic_profiles!group_lessons_coach_id_fkey(id, full_name, bio, avatar_url),
        executing_coach:coach_basic_profiles!group_lessons_executing_coach_id_fkey(id, full_name, bio, avatar_url)
      `)
      .eq('id', lessonId)
      .maybeSingle(),
    supabase.rpc('get_lesson_enrollment_counts', { p_lesson_ids: [lessonId] }),
    clientId
      ? supabase
        .from('lesson_enrollments')
        .select('id, status, waitlist_position')
        .eq('lesson_id', lessonId)
        .eq('client_id', clientId)
        .neq('status', 'cancelled')
      : Promise.resolve({ data: [], error: null }),
    supabase.rpc('get_buddy_enrollments', { p_lesson_ids: [lessonId] }),
  ]);

  if (lessonRes.error) throw lessonRes.error;
  if (!lessonRes.data) return null;
  if (countsRes.error) throw countsRes.error;
  if (ownRes.error) throw ownRes.error;
  if (buddyRes.error) console.error('Buddy-deelname laden mislukt:', buddyRes.error.message);

  const lesson = lessonRes.data;
  return {
    ...lesson,
    executing_coach: lesson.executing_coach || lesson.coach || null,
    enrolled_count: countsRes.data?.[0]?.enrolled_count ?? 0,
    own_enrollment: ownRes.data?.[0] || null,
    buddy_names: (buddyRes.data || []).map(row => row.buddy_name).filter(Boolean),
  };
}

export function trainingLocationLines(lesson) {
  const location = lesson?.location;
  if (location) {
    const street = [location.street, location.house_number].filter(Boolean).join(' ');
    const city = [location.postal_code, location.city].filter(Boolean).join(' ');
    return [location.name, street, city].filter(Boolean);
  }
  const street = [lesson?.custom_location_street, lesson?.custom_location_house_number].filter(Boolean).join(' ');
  const city = [lesson?.custom_location_postal_code, lesson?.custom_location_city].filter(Boolean).join(' ');
  return [lesson?.custom_location_name, street, city].filter(Boolean);
}
